module.exports = __webpack_public_path__ + "media/images/lb/370-54615755e71f6d185135a28b20c26392.svg";